import { filterDuplicates } from '@lts-web/utils/ObjectUtil';

class SelectionList {
    constructor (list = [], options = {}) {
        this.list = list;
        this.options = Object.freeze(Object.assign(SelectionList.defaults, options));
        this.defaultSelection = this.getOption('defaultSelection') || [ ...list ];
    }

    static get defaults () {
        return {
            maxLength: 5,
            multiSelection: false,
            allowEmpty: false,
            allowDuplicates: false,
            defaultSelection: null,
            singleSelections: []
        };
    }

    get length () {
        return this.list.length;
    }

    get isMultiSelection () {
        return this.getOption('multiSelection');
    }

    get isMultiSelected () {
        return this.list.length > 1;
    }

    get isEmpty () {
        return this.length === 0;
    }

    updatedCallback () {}

    getOption (key) {
        return this.options[key];
    }

    getList () {
        return this.list;
    }

    has (item) {
        return this.list.indexOf(item) > -1;
    }

    add (item) {
        const maxLength = this.getOption('maxLength');
        const allowDuplicates = this.getOption('allowDuplicates');
        const isSingleSelectionItem = this.isSingleSelectionItem(item);

        if (isSingleSelectionItem) {
            this.empty(true);
        } else {
            this.emptySingleSelections();
        }

        if (this.list.length === maxLength) {
            return;
        }

        if (this.has(item) && !allowDuplicates) {
            return;
        }

        this.list.push(item);
        this.updatedCallback(item, 'add');
    }

    remove (item) {
        if (this.isEmpty) {
            return;
        }

        const list = this.list;
        const index = list.indexOf(item);
        const allowEmpty = this.getOption('allowEmpty');

        if (index !== -1) {
            list.splice(index, 1);
            if (!allowEmpty && this.isEmpty) {
                this.reset();
                return true;
            }
            this.updatedCallback(item, 'remove');
            return true;
        }

        return false;
    }

    replace (list, force = false) {
        const allowDuplicates = this.getOption('allowDuplicates');

        if (!Array.isArray(list)) {
            throw new TypeError('First argument must be an Array object');
        }

        if (list.length === 0 && !this.getOption('allowEmpty') && !force) {
            return;
        }

        if (!allowDuplicates) {
            list = filterDuplicates(list);
        }

        this.list = list;
        if (force) {
            this.updatedCallback(this.list, 'replace');
        }
    }

    empty (force = false) {
        if (!this.getOption('allowEmpty') && !force) {
            return;
        }

        this.list = [];
        if (force) {
            this.updatedCallback(this.list, 'empty');
        }
    }

    reset () {
        this.list = Array.isArray(this.defaultSelection) ? [...this.defaultSelection] : [ this.defaultSelection ];
        this.updatedCallback(this.list, 'reset');
    }

    emptySingleSelections () {
        if (!this.isMultiSelection) {
            this.empty();
            return;
        }

        const singleSelections = this.getOption('singleSelections');
        this.list = this.list.filter(currItem => singleSelections.indexOf(currItem) === -1) || [];
    }

    isSingleSelectionItem (item) {
        if (!this.isMultiSelection)
            return true;

        return this.getOption('singleSelections').indexOf(item) > -1;
    }

    parse (listString) {
        this.list = listString.spliy(',').map(item => item.trim());
    }

    stringify () {
        return this.list.join(',');
    }
}

export default SelectionList;